import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

interface MobileSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const MobileSidebar = ({
  isOpen,
  onClose,
  children,
}: MobileSidebarProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-40 bg-black/60 lg:hidden backdrop-blur-sm"
            onClick={onClose}
          />

          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed inset-y-0 left-0 z-50 w-[280px] bg-[#0A0A0A] lg:hidden flex flex-col shadow-2xl border-r border-neutral-800"
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
